import { Box, Button, Checkbox, FormControlLabel } from '@mui/material'
import { Item } from '../../../../common/snippets'
import DropDownOA from '../../../../common/dropDownOA'
import Datepicker from '../../../../common/datePicker'
import { SplitButton } from '../../../../common/SplitButton'
import { RefreshSvg } from '../../../../common/svg/refresh'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import * as id from '../../reportId'
import * as lb from '../../reportLables'
import { useState } from 'react'
import FranchiseeToOwnSummary from './FranchiseeToOwnSummary'
import FranchiseeToOwnDetailed from './FranchiseeToOwnDetailed'
import { paymentModesWithAll } from '../../../../common/paymentsMode'
import {
    getFranchiseeToOwnReport,
    getCargoSettingFilterData,
    getCompanyList,
    getOwnBookingFilterData,
} from '../../../../../store/reports/reports_action'
import { connect } from 'react-redux'
import { lrStatusView, lrStatusView1, reportView, transType, urls, userList } from '../../../../common/constants'
import { useEffect } from 'react'
import moment from 'moment/moment'
import { appendToUrl, focusElemnt, isEmpty, isNull, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import * as URL from '../../oldReportsUrls'
import { updateAlert, updateLoader, updateModal } from '../../../../../store/common/common_action'
import { franchiseeTownBookingDetailedColumnsWithFormattedLRNO, franchiseeTownBookingDetailedorPotrateColumns, bookingSummaryColumn } from '../BookingConstants'
import ManageColumns from '../../../../common/ManageColumnsUI'
import { divideInNIntegers } from '../../../../common/mathHelper'
import { PAYTYPE_RULES } from '../franchiseeBookings/FranchiseeBookings'
import { GetRequest } from '../../../../common/api'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../../common/jotaiState/globalStateAtoms'
import { GT_COMPANY_ID } from '../../../../../helper/companyIdhardcode'
import { useAtom } from 'jotai'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../../common/jotaiState/reportStateAtom'

const FranchiseeToOwnNew = (props) => {
    const {
        data: { common, reports },
        getOwnBookingFilterData,
        getCompanyList,
        updateAlert,
        updateModal,
    } = props
    const { loginData, showModal, modalType, roleRights, companySettings } = common
    const { intCompanyID } = loginData
    const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports
    const BookingReportPortrait = companySettings?.[0]?.BookingReportPortrait || 0
    const { DefaultCurrencyID, IsHamaliInBookingReport, UseToPayAsCOD } = companySettings?.[0] || {}

    const loginCountryId = companySettings[0]?.DefaultCurrencyID
    const setLoader = useSetAtom(globalLoaderAtom)
    const setAlert = useSetAtom(alertAtom)
    const { ownBookingDropData, cargoSettingFilterData, reportCompany } = reports
    const { franchiseeToOwn } = reports
    const [clickButton, setClickButton] = useState('')
    const [showReport, setShowReport] = useState(false)
    const [selReportView, setSelReportView] = useState(reportView?.[1])
    //changes
    const [franchCityList, setFranchCityList] = useState([])
    const [franchBranchList, setFranchBranchList] = useState([])
    const [filterFranchBranchList, setFilterFranchBranchList] = useState([])
    const [destCityList, setDestCityList] = useState([])
    const [destBranchList, setDestBranchList] = useState([])
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [tableData, setTableData] = useState([])
    //state for selected dropdown
    const [selCompany, setSelCompany] = useState('')
    const [selFranchCity, setSelFranchCity] = useState('')
    const [selFranchBranch, setSelFranchBranch] = useState('')
    const [selDestCity, setSelDestCity] = useState('')
    const [selDestBranch, setSelDestBranch] = useState('')
    const [selPayment, setSelPayment] = useState({ typeId: 0, type: 'ALL', name: 'All', f: 'none', b: 'none', isEnabled: true })
    const [paymentOptions, setPaymentOptions] = useState([]);
    const [selTxnType, setSelTxnType] = useState(transType?.[0])
    const [selLrStatus, setSelLrStatus] = useState(lrStatusView?.[0])
    const [crossingLr, setCrossingLr] = useState(false)
    const [resetFlag, setResetFlag] = useState(false)
    const [disableExcel, setDisableExcel] = useState(false)
    const [disableBtn, setDisableBtn] = useState(false)
    const [allowViewAllReport, setAllowViewAllReport] = useState(0)
    const [resetBranch, setResetBranch] = useState(false)
    const [manageColumn, setManageColumn] = useState([])
    const { intUserID } = loginData
    const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
    const [ChildCompanyList] = useAtom(ChildCompanyListData)
    const reportName = 'Franchise To Own Booking Report'
    
    const summaryheaders = bookingSummaryColumn.filter(col => {
        if (DefaultCurrencyID === 2 && col.field === 'BookingGST') return false;
        if (!IsHamaliInBookingReport && col.field === 'HamaliCharges') return false;
        return true;
    }).map(col => {
        if (col.field === 'Valuation') {
            return {
                ...col,
                headerName: DefaultCurrencyID === 2 ? 'Insurance\nCharge' : 'Valuation\nCharge',
                exportHead: DefaultCurrencyID === 2 ? 'Insurance\nCharge' : 'Valuation\nCharge',
            };
        }
        return col;
    });
     const criteriaHeaders = [
        { field: 'selCompany', header: 'Selected Company', textAlign: 'left' },
        { field: 'fromDate', header: 'From Booking Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Booking  Date', textAlign: 'left' },
        { field: 'selFranchCity', header: 'Franchisee City', textAlign: 'left' },
        { field: 'selFranchBranch', header: 'Franchisee Branch', textAlign: 'left' },
        { field: 'selFranchUser', header: 'Franchisee Branch User', textAlign: 'left' },
        { field: 'selDestCity', header: 'Destination City', textAlign: 'left' },
        { field: 'selDestBranch', header: 'Destination Branch', textAlign: 'left' },
        { field: 'selPayment', header: 'Payment Type', textAlign: 'left' },
        { field: 'selTxnType', header: 'Txn.Type', textAlign: 'left' },
        { field: 'selReportView', header: 'Report View`', textAlign: 'left' },
    ]
    const criteriaData = {
        selCompany: selCompany?.CompanyName || '',
        fromDate: fromDate.format('DD-MM-YYYY') || '',
        toDate: toDate.format('DD-MM-YYYY') || '',
        selFranchCity: selFranchCity?.SourceCityName || '',
        selFranchBranch: selFranchBranch?.SourceBranchName || '',
        selFranchUser: userList[0]?.UserName || '',
        selDestCity:selDestCity?.DestCityName || '',
        selDestBranch: selDestBranch?.DestBranchName || '',
        selPayment: selPayment?.name || '',
        selTxnType: selTxnType?.TransType || '',
        selReportView: selReportView?.ReportView || '',
        dataType: 'entry',
    }
    useEffect(() => {
        const defaultCompany = ChildCompanyList.find((v) => v.CompanyID === loginData.intCompanyID) || ChildCompanyList[0];
        setSelCompany(defaultCompany)
    }, [ChildCompanyList])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const body = {
                intCompanyID: intCompanyID,
                UserID: intUserID
            }
            fetchChildCompanyList(body)
        }
    }, [loginData])
    useEffect(() => {
        let updatedOptions = paymentModesWithAll.map(item => ({ ...item }));
        if (UseToPayAsCOD === 1) {
            const toPayIndex = updatedOptions.findIndex(item => item.typeId === 2);
            const codOption = updatedOptions.find(item => item.typeId === 4);
            if (toPayIndex !== -1 && codOption) {
                updatedOptions[toPayIndex] = {
                    ...codOption,
                    typeId: 2,
                    name: "COD",
                    roleRightsId: "COD"
                };
            }
            updatedOptions = updatedOptions.filter(item => item.typeId !== 4);
        }
        setPaymentOptions(updatedOptions);
    }, [UseToPayAsCOD]);
    useEffect(() => {
        focusElemnt('selectCompnay')
        const companylistData = {
            intCompanyID: loginData?.intCompanyID,
            intUserID: loginData?.intUserID,
            intMode: 0,
        }
        getCompanyList(companylistData, true, 24 * 60 * 60 * 1000)
    }, [])
    useEffect(() => {
        if (!isEmpty(roleRights) && !isEmpty(loginData)) {
            setDisableBtn(
                !(
                    roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
                    roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
                    loginData?.IsBranchAdmin ||
                    loginData?.IsMTPLAdmin ||
                    loginData?.IsAdmin
                )
            )
            setDisableExcel(!roleRights?.Table1?.[0]?.AllowExportExcel)
        }
        if (roleRights?.Table1?.[0]?.AllowViewAllBranchReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin) {
            setAllowViewAllReport(1)
        }
    }, [roleRights, loginData])
    useEffect(() => {
        if (!isEmpty(ownBookingDropData)) {
            if (ownBookingDropData?.Data?.Table?.length > 0) {
                let data = []
                let data1 = []
                let data2 = []
                let data3 = []
                ownBookingDropData?.Data?.Table?.map((val, i) => {
                    data.push({ SourceCityID: val?.SourceCityID, SourceCityName: val?.SourceCityName })
                    data1.push({ SourceBranchID: val?.SourceBranchID, SourceBranchName: val?.SourceBranchName, SourceCityID: val?.SourceCityID })
                    data2.push({ DestCityID: val?.DestCityID, DestCityName: val?.DestCityName })
                    data3.push({ DestBranchID: val?.DestBranchID, DestBranchName: val?.DestBranchName, DestCityID: val.DestCityID })
                })
                setFranchCityList([{ SourceCityName: 'All Cities', SourceCityID: 0 }, ...data])
                setFranchBranchList([{ SourceBranchName: 'All Branches', SourceBranchID: 0 }, ...data1])
                //for 1st time all list will come in filterbranch
                setFilterFranchBranchList([{ SourceBranchName: 'All Branches', SourceBranchID: 0 }, ...data1])
                setDestCityList([{ DestCityName: 'All Cities', DestCityID: 0 }, ...data2])
                if (disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1) {
                    const destBranchData = data3?.filter((val) => val.DestCityID == loginData?.intBranchCityID)
                    setDestBranchList([{ DestBranchName: 'All Branches', DestBranchID: 0 }, ...destBranchData])
                } else {
                    setDestBranchList([{ DestBranchName: 'All Branches', DestBranchID: 0 }, ...data3])
                }
                if (disableBtn) {
                    setSelDestCity({ DestCityName: loginData?.strCityName, DestCityID: loginData?.intBranchCityID })
                    if (disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1) {
                        const selectedBranch = data3?.filter((val) => val.DestBranchID === loginData?.intBranchID)
                        if (selectedBranch?.length > 0) {
                            setSelDestBranch(selectedBranch?.[0])
                        } else {
                            setSelDestBranch({ DestBranchName: 'All Branches', DestBranchID: 0 })
                        }
                    } else {
                        setSelDestBranch({ DestBranchName: loginData?.strBranchName, DestBranchID: loginData?.intBranchID })
                    }
                   
                } else {
                    const selectedCity = data2?.filter((val) => val.DestCityID === loginData?.intBranchCityID)
                    const selectedBranch = data3?.filter((val) => val.DestBranchID === loginData?.intBranchID)
                    if (selectedCity?.length > 0) {
                        setSelDestCity(selectedCity?.[0])
                    } else {
                        setSelDestCity({ DestCityName: 'All Cities', DestCityID: 0 })
                    }
                    if (selectedBranch?.length > 0) {
                        setSelDestBranch(selectedBranch?.[0])
                    } else {
                        setSelDestBranch({ DestBranchName: 'All Branches', DestBranchID: 0 })
                    }
                }
                setSelFranchCity({ SourceCityName: 'All Cities', SourceCityID: 0 })
                setSelFranchBranch({ SourceBranchName: 'All Branches', SourceBranchID: 0 })
            } else {
                setFranchCityList([])
                setFranchBranchList([])
                setDestCityList([])
                setDestBranchList([])
                setSelDestBranch('')
                setSelDestCity('')
            }
        }
    }, [ownBookingDropData])
    const updatedColumn = franchiseeTownBookingDetailedColumnsWithFormattedLRNO(UseFormattedLRinReports, loginCountryId, UseToPayAsCOD)
    useEffect(() => {
        const getLocalData = (key) => {
            return new Promise((resolve) => {
                const localData = localStorage.getItem(key)
                resolve(localData ? JSON.parse(localData) : null)
            })
        }
        const updateColumnDetails = async () => {
            try {
                if (BookingReportPortrait) {
                    let usedCols = [];
                    const franchiseeTownBookingDetailedorPotrateCol = await getLocalData('franchiseeTownBookingDetailedorPotrateColumns');
                    if (UseFormattedLRinReports !== 3) {
                        usedCols = (franchiseeTownBookingDetailedorPotrateCol || franchiseeTownBookingDetailedorPotrateColumns)
                            .filter((item) => item.field !== 'FormattedLRNO');
                    } else {
                        usedCols = franchiseeTownBookingDetailedorPotrateCol || franchiseeTownBookingDetailedorPotrateColumns;
                    }
                    usedCols = usedCols.map((col) => {
                        if (col.field === 'Valuation') {
                            return {
                                ...col,
                                header: loginCountryId === 2 ? 'Insu.\nChrg.' : 'Val.\nChrg.',
                                exportHead: loginCountryId === 2 ? 'Insu.\nChrg.' : 'Val.\nChrg.',
                            };
                        }
                        if (col.field === 'CartageAmount') {
                            return {
                                ...col,
                                header: 'Addl. \nCartage',
                                exportHead: 'Addl. \nCartage',
                            };
                        }
                        return col;
                    });
                    setManageColumn(usedCols);
                } else {
                    const updatedColumns = await getLocalData('franchiseeTownBookingDetailed');
                    let usedCols = updatedColumns || updatedColumn;
                    usedCols = usedCols
                        .map((col) => {
                            if (DefaultCurrencyID === 2) {
                                if (col.field === 'Valuation') {
                                    return {
                                        ...col,
                                        header: 'Insu.\nChrg.',
                                        exportHead: 'Insurance Charge',
                                    }
                                }
                                if (col.field === 'Sender^^SenderGSTN') {
                                    return {
                                        ...col,
                                        header: 'Sndr. Name',
                                        exportHead: 'Sender Name',
                                    }
                                }
                                if (col.field === 'RecName^^RecGSTN') {
                                    return {
                                        ...col,
                                        header: 'Rcvr. Name',
                                        exportHead: 'receiver Name',
                                    }
                                }
                                if (col.field === 'BookingGST') {
                                    return false
                                }
                            }
                            if (col.field === 'CartageAmount' && intCompanyID === GT_COMPANY_ID) {
                                return {
                                    ...col,
                                    header: 'Addl. \nCartage',
                                    exportHead: 'Additional Cartage',
                                }
                            }
                            return col
                        })
                        .filter(Boolean)
                    setManageColumn(usedCols);
                }
            } catch (error) {
                console.error(error);
            }
        };

        updateColumnDetails()
    }, [UseFormattedLRinReports, BookingReportPortrait, loginCountryId, intCompanyID])
    const onSaveColumns = (items) => {
        setManageColumn(items)
        if (BookingReportPortrait === 1) {
            localStorage.setItem('franchiseeTownBookingDetailedorPotrateColumns', JSON.stringify(items))
        } else {
            localStorage.setItem('franchiseeTownBookingDetailed', JSON.stringify(items))
        }
    }
    const selectedFields = manageColumn.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {})

    const handleAlert = (msg = false, nextId = '') => {
        if (typeof msg === 'string' && !isNull(msg)) {
            updateAlert({ show: true, msg, nextId })
        } else {
            updateAlert({ show: false, msg: '', nextId: '' })
            focusElemnt(nextId)
        }
    }
    const handleFranchBranch = (cityId) => {
        if (cityId !== 0) {
            setResetBranch(true)
            const filteredBranches = franchBranchList.filter((branch) => branch.SourceCityID === cityId)
            setFilterFranchBranchList(filteredBranches)
        } else {
            setFilterFranchBranchList([{ SourceBranchName: 'All Branches', SourceBranchID: 0 }, ...franchBranchList])
        }
    }
    const handleGoClick = () => {
        if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            handleAlert('Selected Date Range Should Be One Month Or Less Than It!')
        } else {
            const obj = {
                CompanyID: selCompany?.CompanyID,
                FromDate: fromDate.format('YYYY-MM-DD'),
                ToDate: toDate.format('YYYY-MM-DD'),
                FranchCompID: loginData.intCompanyID,
            }
            getOwnBookingFilterData(obj)
            focusElemnt(id.ftoCity)
        }
    }
    const handleClick1 = () => {
        setShowReport(true)
        const obj = {
            CompanyID: selCompany?.CompanyID, //selected
            SourceCityID: selFranchCity?.SourceCityID, //franchies city
            SourceBranchID: selFranchBranch?.SourceBranchID, //franchies branch
            DateFrom: fromDate.format('YYYY-MM-DD'),
            DateTo: toDate.format('YYYY-MM-DD'),
            UserID: 0, //default
            FranchCompanyID: loginData.intCompanyID,
            DestCityID: selDestCity?.DestCityID,
            DestBranchID: selDestBranch?.DestBranchID,
            PaymentTypeIDs: selPayment?.typeId || 0,
            Mode: selTxnType?.TransId || 0,
            StatusCode: selLrStatus?.LrId || 0,
            IsCrossingCity: crossingLr ? 1 : 0,
            LoggedInUser: loginData.intUserID,
            AllowViewAllReport: allowViewAllReport,
        }
        setLoader(true)
        GetRequest(urls.BookingFranchiseeReport, obj)
            .then((res) => {
                if (res.status !== 'Success') {
                    throw new Error(res?.ErrMessage || 'Request Failed')
                }
                if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
                    throw new Error('No Data Found')
                }
                // handleGenerate(res.Data.Table)
                let list = res?.Data?.Table

                const updatedData =
                    UseToPayAsCOD === 1
                        ? list.map((item) => ({
                            ...item,
                            PayType: PAYTYPE_RULES[item.PaymentTypeID] || item.PayType,
                        }))
                        : list
                let mainHeader = []
                let manageColIdValue = ''
                if (BookingReportPortrait === 1) {
                    manageColIdValue = 'franchiseeTownBookingDetailedorPotrateColumns'
                } else {
                    manageColIdValue = 'franchiseeTownBookingDetailed'
                }
                let reportPayload = {}
                if (selReportView?.ReportView === 'Detailed') {
                    const headers = manageColumn.filter((item) => item.isSelected)
                    const reportData = groupData(updatedData, headers)
                      mainHeader = manageColumn.filter((obj) => obj.isSelected)?.map((val) => ({
                            ...val,
                            align: val.xlCol.dataType === 'string' ? 'left' : 'right',
                            export: val.exportHead,
                            weight: 80
                        }))
                        reportPayload = {
                            reportName,
                            criteriaHeaders: criteriaHeaders,
                            criteriaData: [criteriaData],
                            tableData: reportData,
                            mainHeader: mainHeader,
                            isShowManageColumn: true,
                            manageColumnID: manageColIdValue,
                        }
                } else {
                    const colspans = divideInNIntegers(summaryheaders.length, 2)
                    const data =
                        updatedData?.map((val, i) => ({
                            ...val,
                            SN: i + 1,
                            DocumentCharges: val.DocumentCharges || 0,
                            dataType: 'entry',
                        })) || []
                    const numericFields = [
                        'LRCount',
                        'ItemUnits',
                        'Freight',
                        'CartageAmount',
                        'HamaliCharges',
                        'DocumentCharges',
                        'Valuation',
                        'OtherCharges',
                        'BookingGST',
                        'Amount',
                        'RefundAmt',
                        'NetAmount',
                        'DocumentCharges',
                    ]
                    const totals = data.reduce((acc, val) => {
                        if (val?.isTotal || val?.isHeading || val?.isSubHeading) return acc

                        numericFields.forEach((field) => {
                            acc[field] += Number(val[field]) || 0
                        })

                        return acc
                    }, Object.fromEntries(numericFields.map((f) => [f, 0])))
                    data.push({
                        ...totals,
                        SN: 'Grand Total',
                        colSpan: { SN: 2 },
                        dataType: 'total',
                    })
                    const headerObject = summaryheaders.reduce(
                        (acc, v) => {
                            acc[v.field] = v.headerName
                            return acc
                        },
                        { dataType: 'header' }
                    )

                    data.unshift(headerObject)
                    data.unshift({
                        [summaryheaders[0].field]: `Source City: ${selFranchCity?.SourceCityName}`,
                        [summaryheaders[colspans[0]].field]: `Destination City: ${selDestCity?.DestCityName}`,
                        dataType: 'header2',
                        colSpan: { SN: colspans[0], [summaryheaders[colspans[0]].field]: colspans[1] },
                    })
                    data.unshift({ SN: 'Booking Report: Franchise To Own', dataType: 'header', colSpan: { SN: summaryheaders.length } })
                        mainHeader = summaryheaders.map((val) => ({
                            ...val,
                            header:val.headerName,
                            align: val.xlCol.dataType === 'string' ? 'left' : 'right',
                            export: val.exportHead,
                            weight: 80
                        }))
                        reportPayload = {
                            reportName,
                            criteriaHeaders: criteriaHeaders,
                            criteriaData: [criteriaData],
                            tableData: data,
                            mainHeader: mainHeader,
                            hideHeader: true
                        }
                }

            })
            .catch((err) => {
                setTableData([])
                setAlert({ show: true, msg: err.message, nextId: '' })
            })
            .finally(() => {
                setLoader(false)
            })
    }
   
    const groupData = (array, headers) => {
        const lengths = divideInNIntegers(headers.length, 3)
        let index = 0
        const pickedHeaders = []
        lengths.forEach((span) => {
            pickedHeaders.push(headers[index].field)
            index += span
        })
        const createEmptyTotals = () => ({
            Quantity: 0,
            Freight: 0,
            CartageAmount: 0,
            HamaliCharges: 0,
            DocumentCharges: 0,
            Valuation: 0,
            OtherCharges: 0,
            BookingGST: 0,
            NetAmount: 0,
        });

        const numericFields = Object.keys(createEmptyTotals());

        const BookedData = [];
        const RefundData = [];
        let BookedTotal = createEmptyTotals();
        let RefundTotal = createEmptyTotals();
        let BookingSN = 0;
        let RefundSN = 0;
        const pushFormattedRow = (val, index) => ({
            ...val,
            dataType: "entry",
            srNo: index + 1,
            itemDesc: val.ItemDetails,
            DstCityBranch: `${val.DestCityName}\n${val.DestBranchName}`,
            BkgDtTimeBy: `${moment(val.BkgDtTime).format("DD-MMM-YY HH:mm")}\n${val.UserBooked}`,
            SenderNameGSTN: `${val.Sender}\n${val.SenderGSTN}`,
            recNameGstin: `${val.RecName}\n${val.RecGSTN}`,
            Status: val.STATUS,
            SenderContEmail: `${val.SenderMobileNo}\n${val.SenderEmailID}`,
            RecContEmail: `${val.RecMobileNo}\n${val.ReceiverEmailID}`,
            "LRNO^^ManualLRNo": `${val.LRNO}\n${val.ManualLRNo}`,
            "Sender^^SenderGSTN": `${val.Sender}\n${val.SenderGSTN}`,
            "SenderMobileNo^^SenderEmailID": `${val.SenderMobileNo}\n${val.SenderEmailID}`,
            "RecMobileNo^^ReceiverEmailID": `${val.RecMobileNo}\n${val.ReceiverEmailID}`,
            "RecName^^RecGSTN": `${val.RecName}\n${val.RecGSTN}`,
            "BkgDtTime^^UserBooked": `${moment(val.BkgDtTime).format("DD-MMM-YY HH:mm")}\n${val.UserBooked}`,
            "DestCityName^^DestBranchName": `${val.DestCityName}\n${val.DestBranchName}`,
        });

        const addToTotal = (totalObj, val) => {
            numericFields.forEach((f) => (totalObj[f] += Number(val[f])));
        };

        array?.forEach((val) => {
            if (val.IsRefund === 0) {
                BookedData.push(pushFormattedRow(val, BookingSN++));
                addToTotal(BookedTotal, val);
            } else {
                RefundData.push(pushFormattedRow(val, RefundSN++));
                addToTotal(RefundTotal, val);
            }
        });

        const makeSubHeading = (type) => ({
            dataType: 'subHeader',
            colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
            align: { [pickedHeaders[0]]: 'left', [pickedHeaders[1]]: 'center', [pickedHeaders[2]]: 'right' },
            [pickedHeaders[0]]: `Source City :${selFranchCity?.SourceCityName}`,
            [pickedHeaders[1]]: `Destination City:${selDestCity?.DestCityName}`,
            [pickedHeaders[2]]: `Transactions: ${type}`,
        })

        const headerCol = headers.reduce((a, c) => ((a[c.field] = c.header), a), {})

        let DetailedData = [];

        const pushSection = (heading, rows, totals, transLabel) => {
            DetailedData.push(
                heading,
                { dataType: 'header', ...headerCol },
                ...rows,
                {
                    dataType: 'total',
                    align: { [pickedHeaders[0]]: 'right' },
                    colSpan: { [pickedHeaders[0]]: headers.findIndex((header) => header.field === 'Quantity') },
                    [pickedHeaders[0]]: `Total:Src.City ${selFranchCity?.SourceCityName}/ Dest. City:${selDestCity?.DestCityName},Trans:${transLabel}`,
                    ...totals,
                }
            );
        };
        if (selTxnType?.TransId === 0 || selTxnType?.TransId === 1)
            pushSection(makeSubHeading("Booked"), BookedData, BookedTotal, "Booked");

        if (selTxnType?.TransId === 0 || selTxnType?.TransId === 2)
            pushSection(makeSubHeading("Refund"), RefundData, RefundTotal, "Refund");

        if (selTxnType?.TransId === 0) {
            const GrandTotal = numericFields.reduce((a, f) => ((a[f] = BookedTotal[f] - RefundTotal[f]), a), {})
            DetailedData.push({
                dataType: 'total',
                align: { [pickedHeaders[0]]: 'right' },
                colSpan: { [pickedHeaders[0]]: headers.findIndex((header) => header.field === 'Quantity') },
                [pickedHeaders[0]]: `Net Total:Src.City ${selFranchCity?.SourceCityName}/ Dest. City:${selDestCity?.DestCityName},Trans:Booked+Refund`,
                ...GrandTotal,
            });
        }
        return DetailedData;
    };
    const handleClick2 = () => {
        if (selTxnType?.TransId === 1) {
            updateAlert({ show: true, msg: 'Booked Trans. Not Allowed' })
        } else {
            let url = URL.BookingFranchiseeReport
            let urlData = URL.BookingFranchiseeReportParams
            urlData.chk = loginData.BusCrsCheckSum
            urlData.dtFromDate = fromDate.format('DD-MMM-YYYY')
            urlData.dtToDate = toDate.format('DD-MMM-YYYY')
            urlData.intCompanyID = selCompany?.CompanyID
            urlData.intBranchID = selFranchBranch.SourceBranchID
            urlData.intpaymentType = selPayment.typeId
            urlData.intUserID = 0 //default
            urlData.intLoggedInUser = loginData?.intUserID
            urlData.Isrefund = selTxnType?.TransId ? 2 : 0 //based on AllTransiction Dropdown
            urlData.AllowViewAllReport = 1
            urlData.companyname = loginData.strCompanyName
            urlData.FranchCompID = loginData?.intCompanyID
            urlData.FranchBranchID = selDestBranch?.DestBranchID //destination branch id
            urlData.isSummaryOnly = selReportView?.[1] ? 1 : 0
            urlData.intAllowExportExcel = 1
            url = appendToUrl(url, urlData)
            window.open(url, '_blank')
        }
    }
    return (
        <>
            <Box sx={sx.reportFlex} style={{ paddingRight: '16px', paddingLeft: '16px' }}>
                <Item sx={sx.itemsxGrow}>
                    <DropDownOA
                        id="selectCompnay"
                        label="Selected Company"
                        data={ChildCompanyList}
                        defaultvalue={selCompany?.CompanyName}
                        disabled={false}
                        onSelect={(val) => setSelCompany(val)}
                        dataKey={`CompanyName`}
                        idKey={`CompanyID`}
                        resetFlag={resetFlag}
                        width="100%"
                    />
                </Item>
                <Item sx={sx.itemsx} className="input--container bookingDatePicker">
                    <Datepicker
                        name={'from_booking_date'}
                        label={lb.fromBookingDate}
                        id={id.fromDate}
                        dateChange={(date) => {
                            setFromDate(date)
                            focusElemnt(id.toDate)
                        }}
                        width="170px"
                    />
                </Item>
                <Item sx={sx.itemsx} className="input--container bookingDatePicker">
                    <Datepicker
                        name={'to_booking_date'}
                        label={lb.toBookingDate}
                        id={id.toDate}
                        dateChange={(date) => {
                            setToDate(date)
                            focusElemnt(id.ftoGoButton)
                        }}
                        width="170px"
                    />
                </Item>
                {/* <Item sx={sx.itemsx}>
                <Button
                  id="goButton"
                  variant="contained"
                  className="go click-button"
                  onClick={handleGoClick}
                  onKeyDown={(e) => navigation3('FranchiseCity', id.toDate, handleGoClick)}
                >
                  GO
                </Button>
              </Item> */}
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button
                        variant="contained"
                        style={{ ...sx.fullHeight, ...sx.novp }}
                        className="btn btn-primary"
                        onClick={handleGoClick}
                        id={id.ftoGoButton}
                        onKeyDown={(e) => navigation3(e, id.ftoCity, id.toDate, handleGoClick)}
                    >
                        GO
                    </Button>
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label="Franchisee City"
                        id={id.ftoCity}
                        data={removeDuplicatesFromArray(franchCityList, 'SourceCityID') || []}
                        dataKey={`SourceCityName`}
                        idKey={`SourceCityID`}
                        defaultvalue={selFranchCity?.SourceCityName || selFranchCity}
                        onSelect={(e) => {
                            setShowReport(false)
                            setSelFranchCity(e)
                            handleFranchBranch(e.SourceCityID)
                        }}
                        width="170px"
                        resetFlag={resetFlag}
                        nextId={id.ftoBranch}
                        prevId={id.ftoGoButton}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label="Franchisee Branch"
                        id={id.ftoBranch}
                        data={removeDuplicatesFromArray(filterFranchBranchList, 'SourceBranchID') || []}
                        dataKey={`SourceBranchName`}
                        idKey={`SourceBranchID`}
                        defaultvalue={selFranchBranch?.SourceBranchName || selFranchBranch}
                        onSelect={(e) => {
                            setShowReport(false)
                            setResetBranch(false)
                            setSelFranchBranch(e)
                        }}
                        width="170px"
                        resetFlag={resetBranch || resetFlag}
                        nextId={id.ftoDestinationCity}
                        prevId={id.ftoCity}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label="Franchise Branch User"
                        id={id.ftoBranchUser}
                        defaultvalue={userList[0]?.UserName}
                        data={userList || []}
                        dataKey={`UserName`}
                        idKey={`UserID`}
                        width="170px"
                        disabled={true}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label="Destination City"
                        id={id.ftoDestinationCity}
                        data={removeDuplicatesFromArray(destCityList, 'DestCityID') || []}
                        dataKey={`DestCityName`}
                        idKey={`DestCityID`}
                        defaultvalue={selDestCity?.DestCityName || selDestCity}
                        onSelect={(e) => {
                            setShowReport(false)
                            setSelDestCity(e)
                        }}
                        resetFlag={resetFlag}
                        nextId={id.ftoDestinationBranch}
                        prevId={id.ftoBranch}
                        width="170px"
                        disabled={disableBtn}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label="Destination Branch"
                        id={id.ftoDestinationBranch}
                        data={removeDuplicatesFromArray(destBranchList, 'DestBranchID') || []}
                        dataKey={`DestBranchName`}
                        idKey={`DestBranchID`}
                        defaultvalue={(destBranchList?.length > 0 && selDestBranch?.DestBranchName) || selDestBranch}
                        onSelect={(e) => {
                            setShowReport(false)
                            setSelDestBranch(e)
                        }}
                        resetFlag={resetFlag}
                        nextId={id.ftoPaymentType}
                        prevId={id.ftoDestinationCity}
                        width="170px"
                        disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label={'Payment Type'}
                        // data={paymentModesWithAll || []}
                        data={(paymentModesWithAll || []).map((item) => {
                            if (UseToPayAsCOD === 1) {
                                if (item.typeId === 2) {
                                    return { ...item, name: 'COD' };
                                }
                                if (item.typeId === 7) {
                                    return { ...item, name: 'COD Manual' };
                                }
                                if (item.typeId === 9) {
                                    return { ...item, name: 'COD DDDV' };
                                }
                                if (item.typeId === 4) {
                                    return null;
                                }
                            }
                            return item;
                        }).filter(Boolean)
                        }
                        multiSelect={true}
                        id={id.ftoPaymentType}
                        defaultvalue={selPayment?.name || ''}
                        width="100%"
                        searchPlaceholder={`Search By Payment Type`}
                        tabIndex="2"
                        dataKey={`name`}
                        idKey={`typeId`}
                        onSelect={(e) => {
                            setShowReport(false)
                            setSelPayment(e)
                        }}
                        resetFlag={resetFlag}
                        nextId={id.ftoTransactionType}
                        prevId={id.ftoDestinationBranch}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label="Txn.Type"
                        id={id.ftoTransactionType}
                        defaultvalue={transType[0]?.TransType}
                        data={transType}
                        onSelect={(e) => {
                            setShowReport(false)
                            setSelTxnType(e)
                        }}
                        dataKey={`TransType`}
                        idKey={`TransId`}
                        width="170px"
                        resetFlag={resetFlag}
                        nextId={id.ftoReportView}
                        prevId={id.ftoPaymentType}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id={id.ftoReportView}
                        label="Report View"
                        data={reportView}
                        defaultvalue={reportView[1]?.ReportView}
                        dataKey={`ReportView`}
                        onSelect={(e) => {
                            setShowReport(false)
                            setSelReportView(e)
                        }}
                        idKey={`ReportId`}
                        width="170px"
                        resetFlag={resetFlag}
                        nextId={id.ftoLrStatus}
                        prevId={id.ftoTransactionType}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id={id.ftoLrStatus}
                        label="LR Status"
                        data={crossingLr ? lrStatusView1 : lrStatusView}
                        defaultvalue={lrStatusView[0]?.LrStatus}
                        dataKey={`LrStatus`}
                        onSelect={(e) => {
                            setShowReport(false)
                            setSelLrStatus(e)
                        }}
                        idKey={`LrId`}
                        width="170px"
                        listWidth={'250px'}
                        resetFlag={resetFlag}
                        nextId={id.ftoisCrossingCheck}
                        prevId={id.ftoReportView}
                    />
                </Item>
                <FormControlLabel
                    id={id.ftoisCrossingCheck}
                    value="end"
                    control={<Checkbox id={id.onlyRefund} />}
                    className={`${crossingLr ? 'selcheck' : 'unselcheck'}`}
                    label="Include Crossing LRs?"
                    labelPlacement="end"
                    checked={crossingLr}
                    onChange={() => {
                        setCrossingLr(!crossingLr)
                        focusElemnt(id.ftoSplitButton)
                    }}
                    onKeyDown={(e) => {
                        navigation3(e, id.ftoSplitButton, id.ftoLrStatus)
                    }}
                />

                <Item
                    sx={sx.itemsx}
                    onKeyDown={(e) =>
                        navigation3(
                            e,
                            showReport ? (disableExcel ? 'franchToOwnPdfBtn' : 'franchToOwnExcelbtn') : 'selectCompnay',
                            id.ftoisCrossingCheck,
                            () => handleClick1()
                        )
                    }
                >
                    {/* sx={sx.itemsx} */}
                    <SplitButton
                        options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                        id1={id.ftoSplitButton}
                        prevID={id.ftoisCrossingCheck}
                        onClick1={handleClick1}
                        onClick2={handleClick2}
                    />
                </Item>
                <Item
                    sx={{ ...sx.itemsx }}
                    onClick={() => {
                        setResetFlag(!resetFlag)
                    }}
                >
                    <RefreshSvg />
                </Item>
            </Box>
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    getFranchiseeToOwnReport,
    getCompanyList,
    getCargoSettingFilterData,
    getOwnBookingFilterData,
    updateModal,
    updateAlert,
    updateLoader,
}
export default connect(mapStateToProps, mapDispatchToProps)(FranchiseeToOwnNew)
